import './Button.css';
import flashImg from '../../components/atomic/buttons/button/flash.png';
import textImg from './button_text.png';

type ButtonProps = {
  onClick?: () => void;
};

/** From start_game_button (15:7229) — yellow CTA with masked diagonal sheens. */
export function Button({ onClick }: ButtonProps) {
  return (
    <button
      type="button"
      className="welcome-start-button"
      aria-label="Взять первый заказ"
      onClick={onClick}
    >
      <span className="welcome-start-button__sheen welcome-start-button__sheen--wide" aria-hidden />
      <span className="welcome-start-button__sheen welcome-start-button__sheen--mid" aria-hidden />
      <span className="welcome-start-button__sheen welcome-start-button__sheen--soft" aria-hidden />
      <img
        className="welcome-start-button__flash"
        src={flashImg}
        alt=""
        draggable={false}
      />
      <img
        className="welcome-start-button__text"
        src={textImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
